import React from 'react'
import ReactDOM from 'react-dom'
import singleSpaReact from 'single-spa-react'
import Root from './root.component'
import { ErrorLottie } from '@yuno/dashboard-container-mfe'

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Root,
  errorBoundary: (err: any) => {
    return <ErrorLottie />
  },
})

export const { bootstrap, mount, unmount } = lifecycles
